@let conversation = conversationSg();
@let selectedConversationId =
  assistantGroup.conversation.plugins.currentEntityPlugin.feature.selectors
    .getId()
    .asSignal();
@let deletedConversation =
  assistantGroup.conversation.plugins.editingPlugin.feature.selectors
    .getDeletedEntity(conversation.id)
    .asSignal();
@let editedConversation =
  assistantGroup.conversation.plugins.editingPlugin.feature.selectors
    .getEditedEntity(conversation.id)
    .asSignal();

@let isSubmitting =
  assistantGroup.conversation.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal();

<button
  class="conversation-item"
  [class.conversation-item--active]="conversation.id === selectedConversationId"
  [class.conversation-item--read-only]="!isOwner()"
  type="button"
  (click)="selectConversation()"
>
  <i class="atn-icon atn-comment conversation-item__icon"></i>
  <span class="conversation-item__label">{{ conversation.name }}</span>
  <div class="conversation-item__tag-group">
    @if (isShared()) {
      <atn-ds-tag
        class="conversation-item__badge"
        [text]="isOwner() ? 'Shared' : 'Shared with me'"
        [style]="sharedTagStyle.Info"
      />
    }
    <atn-ds-tag
      class="conversation-item__badge"
      [text]="agentName()"
    />
  </div>
  @if (isOwner()) {
    <div class="conversation-item__actions">
      <i
        class="atn-icon atn-edit atn-blue"
        title="Edit conversation"
        (click)="editConversation($event)"
      ></i>
      <i
        class="atn-icon atn-trash atn-red"
        title="Delete conversation"
        (click)="deleteConversation($event)"
      ></i>
    </div>
  }
</button>

@if (deletedConversation) {
  <atn-ds-confirmation-overlay
    title="Delete Conversation"
    [description]="
      'Are you sure you want to delete <b>' +
      deletedConversation.name +
      '</b>? This action cannot be undone.'
    "
    [validation]="deletedConversation.name"
    (cancel)="cancelDeleteConversation()"
    (confirm)="confirmDeleteConversation()"
    [loading]="isSubmitting"
    confirmButtonText="Delete"
  />
}

@if (editedConversation) {
  <atn-ds-centered-overlay>
    <atn-ds-widget title="Update Conversation">
      <i
        actions
        class="atn-icon atn-close atn-red"
        (click)="cancelEditConversation()"
      ></i>
      <div class="conversation-item__edit-dialog-content">
        <atn-ds-text
          label="Name"
          placeholder="Enter conversation name"
          [value]="editedConversation.name"
          (change)="updateConversation({ name: $event ?? '' })"
        />
        <atn-ds-select-single
          label="Workspace"
          [items]="workspaceItems()"
          [config]="{
            overlay: {
              hasSearch: true,
            },
          }"
          [required]="true"
          [value]="editedConversation.workspaceId"
          (valueChange)="updateConversation({ workspaceId: $event })"
        />
        <atn-ds-select-multiple
          label="Shared with"
          [items]="store.userItems()"
          [config]="{ overlay: { hasSearch: true } }"
          [value]="editedConversation.sharedWith ?? []"
          (valueChange)="updateConversation({ sharedWith: $any($event) })"
        />
      </div>
      <div
        footer
        class="conversation-item__edit-dialog-footer"
      >
        <atn-ds-button
          type="transparent"
          (click)="cancelEditConversation()"
          [disabled]="isSubmitting"
        >
          Cancel
        </atn-ds-button>
        <atn-ds-button
          (click)="saveConversation()"
          [loading]="isSubmitting"
          >Save</atn-ds-button
        >
      </div>
    </atn-ds-widget>
  </atn-ds-centered-overlay>
}
